import React from 'react';
import { Phone, MapPin, User } from 'lucide-react';

const Row = ({ icon: Icon, label, value, href }) => {
  const Content = (
    <div className="flex items-start gap-3">
      <div className="w-9 h-9 rounded-full bg-white border border-[#E7E8EC] flex items-center justify-center shrink-0">
        <Icon className="w-4 h-4 text-[#6E56E7]" strokeWidth={2} />
      </div>
      <div className="leading-tight">
        <div className="text-[11px] font-semibold tracking-[0.16em] text-slate-500 uppercase">{label}</div>
        <div className="mt-1 text-[15px] font-semibold text-[#111111]">{value}</div>
      </div>
    </div>
  );
  return href ? (
    <a href={href} className="block hover:opacity-80 transition">{Content}</a>
  ) : Content;
};

const ContactCard = () => (
  <div className="rounded-[22px] bg-[#F6F7F9] border border-[#E7E8EC] p-6 sm:p-7 h-full">
    <div className="text-[11px] font-semibold tracking-[0.2em] text-slate-500 uppercase mb-5">
      Kontakt
    </div>
    <div className="grid grid-cols-1 gap-5">
      <Row icon={Phone}  label="Telefon"        value="015153764622" href="tel:+4915153764622" />
      <Row icon={MapPin} label="Adresse"        value="Gänsemarkt 47, 20354 Hamburg" />
      <Row icon={User}   label="Geschäftsführer" value="Karan Thijeepan" />
    </div>
  </div>
);

export default ContactCard;
